


@if (currentSite === 'seqirusb2b-flu360') {
  @if (showloader) {
    <div class="loading" >
      <div class="loading_txt">
        <div class="load_txt">Loading</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  <div class="yCmsContentSlot row dashboard-splitscetion">
    <div class="col-sm-12 col-lg-6 dashboard-invoicesection dashboard-invoicesection float_left">
      <div class="dashboard-invoicesection-header ">{{'invoice.title' | cxTranslate}}</div>
      @if (invoiceNode) {
        <div class="dashboard-invoicesection-text" >
          <div class="invoice-para"[innerHTML]="'invoice.paragraph1' | cxTranslate : { invoice: invoiceNode.invoiceCount }"></div>
          @if (invoiceNode) {
            <div class="dashboard-invoicesection-text header">
              <div [innerHTML]="'invoice.paragraph2' | cxTranslate : { invoiceamount: invoiceNode.invoiceTotalAmount | number:'1.2-2'}"></div>
            </div>
          }
          <div class="dashboard-viewall dashboard-viewinvociemargin dashboard-viewinvociemargin">
            <a class="anchorunderline" routerLink="/financial-dashboard">{{'invoice.linktext' | cxTranslate}}<i class="global_blackarrow"></i></a>
          </div>
        </div>
      }
    </div>
    <div class="col-sm-12 col-lg-6 dashboard-creditsection dashboard-creditsection float_left">
      <div class="dashboard-invoicesection-header">{{'credit.title' | cxTranslate}}</div>
      @if (invoiceNode) {
        <div class="dashboard-invoicesection-text dashboard-invoicesection-text" [innerHTML]="'credit.paragraph1' | cxTranslate : { creditavailable: invoiceNode.returnsandcreditsTotalAmount}"></div>
      }
      <div class="dashboard-invoicesection-text dashboard-invoicesection-text1 hold"  [innerHTML]="'credit.paragraph2' | cxTranslate"></div>
      <div class="dashboard-viewall dashboard-viewcreditmargin">
        <a class="anchorunderline" routerLink="/financial-dashboard">{{'credit.linktext' | cxTranslate}}<i class="global_blackarrow"></i></a>
      </div>
    </div>
  </div>
}

@if (currentSite === 'seqirusb2b-uk' && rbavalue?.hasManageFin==true) {
  <div class="yCmsContentSlot row dashboard-splitscetion dashboard-splitscetionuk">
    <div class="col-sm-12 col-lg-6 dashboard-invoicesection dashboard-invoicesectionuk float_left">
      <div class="dashboard-invoicesection-header">{{'invoice.uktitle' | cxTranslate}}</div>
      @if (invoiceNode) {
        <div class="dashboard-invoicesection-text" >
          <div [innerHTML]="'invoice.paragraph1' | cxTranslate : { invoice: invoiceNode.invoiceCount }"></div>
        </div>
      }
      <div class="dashboard-viewall dashboard-viewinvociemargin dashboard-viewinvociemarginuk">
        <a class="anchorunderline" routerLink="/financial-dashboard/all-invoices">{{'invoice.linktext' | cxTranslate}}</a>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6 dashboard-creditsection dashboard-creditsectionuk float_left">
      <div class="dashboard-invoicesection-header">{{'credit.uktitle' | cxTranslate}}</div>
      @if (invoiceNode) {
        <div class="dashboard-invoicesection-text dashboard-invoicesectionuk-text" [innerHTML]="'credit.ukparagraph1' | cxTranslate : { creditavailable: invoiceNode.returnsandcreditsTotalAmount }"></div>
      }
      <!-- <div class="dashboard-invoicesection-text dashboard-invoicesectionuk-text1" appRouterlinkinterceptor [innerHTML]="'credit.ukparagraph2' | cxTranslate"></div> -->
    </div>
  </div>
  <div class="dashboard-invoicesection-text dashboard-invoicesectionuk-text1">
    <p>{{'credit.ukparagraph2' | cxTranslate}}</p>
    <a routerLink="/help-and-faq" class="help-FaqBtn">{{'credit.ukHelpFaqBtn' | cxTranslate}}</a>
  </div>
}

